/**
 * Sorti de `pages/DistributorClientDetail.jsx` le 26/10 (lot L1, fichier > 500 lignes),
 * sans changement de comportement.
 */
import { useNavigate } from 'react-router-dom';
import { fmtDateShort } from '@/features/distributeur/dates';

/**
 * Un chantier propose par un refus de reference ambigue.
 *
 * Le distributeur ne voit ni nom ni adresse : ce module existe pour cela. Ce qui reste
 * pour distinguer deux homonymes est donc la date de pose, le poseur et ce qui a ete
 * installe — exactement ce dont dispose quelqu'un qui a le bon de livraison sous les
 * yeux.
 *
 * Un chantier sans identifiant n'est PAS un lien : la reprise des identifiants ne lui
 * en a pas encore pose un, et un lien mort serait pire qu'une ligne grisee qui le dit.
 */
export default function ChantierPropose({ chantier }) {
  const navigate = useNavigate();
  const resume = [
    chantier.nombre_equipements > 1
      ? `${chantier.nombre_equipements} équipements`
      : `${chantier.nombre_equipements} équipement`,
    (chantier.types || []).join(', '),
    chantier.date_installation ? `posé le ${fmtDateShort(chantier.date_installation)}` : '',
    chantier.installateur_nom,
  ].filter(Boolean).join(' · ');

  if (!chantier.ouvrable) {
    return (
      <div className="w-full text-left border border-dashed border-neutral-200 rounded-lg p-3 bg-neutral-50"
           data-testid="chantier-propose-sans-identifiant">
        <p className="text-[13px] font-medium text-neutral-500">
          {chantier.reference_affichee || chantier.reference_chantier} — sans identifiant
        </p>
        <p className="text-[11.5px] text-neutral-400 mt-0.5">{resume}</p>
      </div>
    );
  }
  return (
    <button
      type="button"
      onClick={() => navigate(`/sav/chantier/${encodeURIComponent(chantier.reference_unique)}`)}
      className="w-full text-left border border-neutral-200 rounded-lg p-3 hover:border-marque hover:bg-neutral-50 transition-colors"
      data-testid={`chantier-propose-${chantier.reference_unique}`}
    >
      <p className="text-[13px] font-medium text-neutral-900">{chantier.reference_affichee}</p>
      <p className="text-[11.5px] text-neutral-500 mt-0.5">{resume}</p>
    </button>
  );
}
